export var WorkorderCategory;
(function (WorkorderCategory) {
    WorkorderCategory[WorkorderCategory["Werkplaats"] = 1] = "Werkplaats";
    WorkorderCategory[WorkorderCategory["Levering"] = 3] = "Levering";
    WorkorderCategory[WorkorderCategory["Levering_ipv_reparatie"] = 4] = "Levering_ipv_reparatie";
    WorkorderCategory[WorkorderCategory["Projecten"] = 5] = "Projecten";
    WorkorderCategory[WorkorderCategory["Intern"] = 10] = "Intern";
    WorkorderCategory[WorkorderCategory["Preventief_onderhoud"] = 11] = "Preventief_onderhoud";
    WorkorderCategory[WorkorderCategory["Inspectie_en_trillingsmetingen"] = 13] = "Inspectie_en_trillingsmetingen";
    WorkorderCategory[WorkorderCategory["Modificaties_in_WP"] = 16] = "Modificaties_in_WP";
    WorkorderCategory[WorkorderCategory["Verspaning"] = 17] = "Verspaning";
})(WorkorderCategory || (WorkorderCategory = {}));
